import React, { useEffect, useState } from "react";
import { Navbar, Row, Col, Nav, Button, Container } from "react-bootstrap";
import Logo from "../../assets/img/logo.svg";
import "./Navbar.scss";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

import {
  AppInput,
  FontAwesomeIcons,
} from "@dcam/dcam_flhealth_component_library";
import { faCaretDown, faCaretUp } from "@fortawesome/pro-solid-svg-icons";
import { faCircleUser } from "@fortawesome/pro-regular-svg-icons";
import MenuSidebar from "../MenuSideBar/MenuSidebar";
import AppButton from "../AppButton/AppButton";
import useGetData from "../../hooks/useGetData";
import { useRef } from "react";

function NavigationBar() {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const [show, setShow] = useState<any>(false);

  const handleShow = () => {
    setShow((prevShow: any) => !prevShow);
  };

  const handleLogin = () => {
    instance.loginRedirect().catch((error) => {
      console.error("Login error: ", error);
    });
  };

  const handleLogout = () => {
    //Clear all sessionStorage
    sessionStorage.clear();
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  const handleLogoClick = () => {
  window.location.href = "/dashboard";
};
  //const [userDetails, setUserDetails] = useState<any>({});

  const { getDataById: getUserId } = useGetData<any, string>(
    "UserSecurity/GetUserSecurityByEmail/" + account.username,
    "GET"
  );

   const getEnvironment = () => {
    let url = window?.location?.hostname;
    if (url.toLocaleLowerCase().includes('test')) {
        return 'Test Environment';
    } else if (url.toLocaleLowerCase().includes('dev')) {
        return 'Dev Environment';
    } else if (url.toLocaleLowerCase().includes('staging')) {
        return 'Staging Environment';
    } else if (url.toLocaleLowerCase().includes('local')) {
        return 'Local Environment';
    }
}

  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);

  const hasFetched = useRef(false); // Declare outside useEffect


  interface UserDetails {
    roleName: string;
    routinizedHospitalName: string;
    // Add other properties based on your API response
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUserId("");
        if (userData?.user) {
          setUserDetails({ ...userData.user }); // Update state
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (isAuthenticated && !hasFetched.current) {
      hasFetched.current = true; // Mark as fetched
      fetchUserData();
    }
  }, [isAuthenticated, getUserId]); // Dependency array

  return (
    <>
      <Navbar
        bg=""
        color="white"
        className="fhs-navbar"
        style={{ backgroundColor: "#004E6A !important" }}
      >
        {/* <Row className="mb-3">
        <Col md={1} className="div-right-center">
          <img src={Logo} alt={"Logo"} />
        </Col>
        <Col md={6}>
        <h2 style={{ fontSize: "2rem" }}>
              <b>Florida Health Care Lookup Portal</b>
            </h2>
        </Col>
        <Col md={2} >
         test
        </Col>
        <Col md={2}>
          test
        </Col>
        </Row> */}
        <div className="d-flex flex-row p-10 flex-column-fluid">
          <div className="d-flex flex-row-fluid flex-left me-4 me-md-4">
            <img src={Logo} alt={"Logo"} onClick={handleLogoClick} className="cursor-pointer navbar-logo"/>
          </div>
          <div
            className="d-flex flex-row-fluid flex-left me-4 me-md-4"
          // style={{ marginLeft: "-100%" }}
          >
           <Row  style={{ textAlign: "center"}}>
            <h2 style={{ fontSize: "2rem" }}>
              <b>Florida Health Care Lookup Portal</b>
               <br />
              <b style={{ color: "red", textAlign: "center", padding: "10px" }}>{getEnvironment()}</b>
            </h2>
            </Row>
          </div>

          {isAuthenticated ? (
            <>
              <div className="me-4" style={{ marginRight: "30%" }}>
                <strong>Role:</strong> {userDetails?.roleName || "N/A"}
                <br />
                {userDetails?.roleName !== "Admin" && (
                  <div>
                    <strong>Hospital:</strong> {userDetails?.routinizedHospitalName || "N/A"}
                  </div>)
                }
              </div>
              {/* <div className="d-flex flex-row-fluid flex-center me-4 me-md-4 custom-style"> */}
              <div>
                <div onClick={handleShow} className="user-info__name" style={{ display: "flex",cursor: "pointer" }}>
                  <FontAwesomeIcons iconName={faCircleUser} iconSize="2x" />
                  &nbsp;&nbsp;
                  {account.name}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex flex-row flex-fill me-4 me-md-4 custom-style">
                &nbsp;&nbsp;
                <AppButton onClick={handleLogin} variant={"primary"}>
                  {" "}
                  Login{" "}
                </AppButton>
              </div>
            </>
          )}
        </div>
      </Navbar>
      <MenuSidebar
        handleClose={handleShow}
        show={show}
        handleLogout={handleLogout}
        roleId={0}
      />
    </>
  );
}

export default NavigationBar;
function getAllClients(arg0: string) {
  throw new Error("Function not implemented.");
}

function setClientData(data: void) {
  throw new Error("Function not implemented.");
}

